export default "__VITE_ASSET__BpstghpO__"